/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { SrsClientAPI } from './services/srs-client-api';
import { LegacyAPI } from './services/legacy-api';
import { RoutersAPI } from './services/routers-api';
import { FirmwaresAPI } from './services/firmwares-api';
import { IamAPI } from './services/iam-api';
import { IamTenantAPI } from './services/iam-tenant-api';
import { RoutersEventsAPI } from './services/routers-events-api';
import { RouterTypeAPI } from './services/router-type-api';
import { SimAPI } from './services/sim-api';
import { VpnAPI } from './services/vpn-api';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    SrsClientAPI,
    LegacyAPI,
    RoutersAPI,
    FirmwaresAPI,
    IamAPI,
    IamTenantAPI,
    RoutersEventsAPI,
    RouterTypeAPI,
    SimAPI,
    VpnAPI,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
